const dispatchRenameBread = (name: string) => {
  const event: any = new Event('dispatch_micro_breadCrumb_name');
  event.value = name;

  // 提交 dispatch_micro_breadCrumb_name 事件
  window.dispatchEvent(event);
}

export default dispatchRenameBread;
